import React from "react"
import { Link } from "react-router-dom"
import { Alert, Modal, CardBody, Form, Button, Card } from "reactstrap"
import InputMask from "react-input-mask"
import NotificationAlert from "react-notification-alert"
import { connect } from "react-redux"
import readXlsxFile from "read-excel-file"
import $ from "jquery"
import moment from "moment"
import reduxHelper from "../../../../helper/index.js"
import api from "../../../../Api.js"
import Select from "react-dropdown-select"

class ImportXlsxUser extends React.Component {
  constructor(props) {
    super(props)
    this.setStateTop = this.props.setState
    this.checkXlsx = this.checkXlsx.bind(this)
    this.state = {
      usersList: [],
      importError: "",
      erroXLSX: "",
      verificado: false,
      removingExisting: false,
      removingExistingProgress: { verified: 0, total: 0 },
      verifyingData: false,
      verifyingDataProgress: { verified: 0, total: 0 },
      cadastrando: false,
      cadastrandoProgress: { current: 0, total: 0 }
    }
    this.changeValue = this.changeValue.bind(this)
    this.reset = this.reset.bind(this)
    this.checkXlsxServer = this.checkXlsxServer.bind(this)
    this.helper = new reduxHelper(this.props)
    this.cadastrar = this.cadastrar.bind(this)
    this.removeLine = this.removeLine.bind(this)
    this.addLine = this.addLine.bind(this)
    this.manual = this.manual.bind(this)
    this.removeExistingUsers = this.removeExistingUsers.bind(this)

    window.importxlsx = this
  }

    normalizeTurmaName(str) {
    if (str == null || typeof str !== "string") return ""
    return str
      .toLowerCase()
      .trim()
      .normalize("NFD")
      .replace(/\p{Diacritic}/gu, "")
  }

  async manual() {
    await this.setState({ usersList: [], importError: "" })
    this.addLine()
  }

  removeLine(index) {
    const usersList = [...this.state.usersList]
    usersList.splice(index, 1)
    this.checkXlsxServer()
    this.setState({ usersList })
  }

  addLine() {
    const usersList = [...this.state.usersList]
    usersList.push({
      name: "",
      lastName: "",
      email: "",
      username: "",
      birthDate: "",
      accessLevel: "",
      blockedQRcode: "",
      blocked: "",
      classRoom: [],
      genre: "",
      classRooms: JSON.parse(JSON.stringify(this.props.state.classRoom))
    })
    this.setState({ usersList, verificado: false })
  }

  async cadastrar() {
    const data = JSON.parse(JSON.stringify(this.filterUsers(this.state.usersList)))
    const total = data.length
    const createdUserIds = []
    const failures = []

    this.setState({
      cadastrando: true,
      cadastrandoProgress: { current: 0, total }
    })
    try {
      for (let i = 0; i < data.length; i++) {
        this.setState({ cadastrandoProgress: { current: i + 1, total } })
        const classRoomsSelected = JSON.parse(JSON.stringify(data[i].classRoom))
        delete data[i].classRoom
        data[i].blockedReason = ""

        try {
          const postUser = await this.props.postUser(1, data[i])
          if (!postUser) break
          for (let c = 0; c < classRoomsSelected.length; c++) {
            try {
              await api.addUserClassRoom({
                classroom: classRoomsSelected[c].id,
                user: postUser.user.id,
                type: parseInt(classRoomsSelected[c].type, 10) 
              })
            } catch (e) {
              failures.push({
                idx: i + 1,
                userId: postUser.user.id,
                classroom: classRoomsSelected[c].id,
                msg: e?.response?.data?.msg || e?.message || 'Erro desconhecido ao vincular turma'
              })
              try { await api.deleteUser(postUser.user.id) } catch {}
              continue
            }
          }
          createdUserIds.push(postUser.user.id)
        } catch (e) {
          break
        }
      }

      // Se houve falhas no vínculo, informe quais e NÃO remova quem já deu certo
      if (failures.length > 0) {
        this.refs.notificationAlert.notificationAlert({
          place: "tr",
          message: (
            <div className="alert-text">
              <span className="alert-title" data-notify="title">Atenção!</span>
              <span data-notify="message">
                {`${failures.length} usuário(s) não foram vinculados à(s) turma(s).`}<br/>
                {failures.slice(0, 5).map((f, k) => (<div key={k}>Linha {f.idx}: turma #{f.classroom} — {f.msg}</div>))}
                {failures.length > 5 ? <div>...</div> : null}
              </span>
            </div>
          ),
          type: "warning",
          icon: "fas fa-exclamation",
          autoDismiss: 10
        })
      }

      this.setStateTop({ openModalImport: false })
      this.reset()
      this.refs.notificationAlert.notificationAlert({
        place: "tr",
        message: (
          <div className="alert-text">
            <span className="alert-title" data-notify="title">{`${this.props.translate["sucesso"]}! `}</span>
            <span data-notify="message">{this.props.translate["a_importacao_foi_realizada"]}</span>
          </div>
        ),
        type: "success",
        icon: "ni ni-check-bold",
        autoDismiss: 7
      })
      this.props.getAllUsers()
    } finally {
      this.setState({
        cadastrando: false,
        cadastrandoProgress: { current: 0, total: 0 }
      })
    }
  }

  async checkXlsxServer() {
    const fullList = this.filterUsers(this.state.usersList)
    const total = fullList.length
    if (total === 0) {
      await this.setState({ erroXLSX: "Nenhum usuário para verificar." })
      return
    }

    const CHUNK_SIZE = 150
    const usernames = fullList.map(u => (u.username || "").toString().toLowerCase().trim())
    const emails = fullList.map(u => (u.email || "").toString().toLowerCase().trim())
    const dupUser = usernames.filter((u, i) => u && usernames.indexOf(u) !== i)
    const dupEmail = emails.filter((e, i) => e && emails.indexOf(e) !== i)
    if (dupUser.length > 0) {
      await this.setState({ erroXLSX: "Usuários duplicados na planilha: " + [...new Set(dupUser)].slice(0, 5).join(", ") + (dupUser.length > 5 ? "..." : "") })
      return
    }
    if (dupEmail.length > 0) {
      await this.setState({ erroXLSX: "E-mails duplicados na planilha: " + [...new Set(dupEmail)].slice(0, 5).join(", ") + (dupEmail.length > 5 ? "..." : "") })
      return
    }

    this.setState({
      verifyingData: true,
      verifyingDataProgress: { verified: 0, total }
    })
    try {
      if (total <= CHUNK_SIZE) {
        this.setState({ verifyingDataProgress: { verified: total, total } })
        const data = await this.helper.user().userCheckXlsx(fullList)
        if (!data) {
          await this.setState({ erroXLSX: "Erro de conexão com o servidor. Tente novamente." })
          return
        }
        if (parseInt(data.status) === 200) {
          await this.setState({ erroXLSX: "", verificado: true })
        } else {
          const msg = data.data?.data?.msg || "Erro ao validar dados. Verifique os campos."
          await this.setState({ erroXLSX: msg })
        }
        return
      }

      this.setState({ erroXLSX: "", verificado: false })
      for (let start = 0; start < total; start += CHUNK_SIZE) {
        const end = Math.min(start + CHUNK_SIZE, total)
        const chunk = fullList.slice(start, end)
        const payload = { list: chunk, startIndex: start }
        this.setState({ verifyingDataProgress: { verified: end, total } })
        const data = await this.helper.user().userCheckXlsx(payload)
        if (!data) {
          await this.setState({ erroXLSX: "Erro de conexão ao verificar linhas " + (start + 1) + "-" + end + ". Tente novamente." })
          return
        }
        if (parseInt(data.status) === 400 || parseInt(data.status) === 500) {
          const msg = data.data?.data?.msg || "Erro ao validar dados. Verifique os campos."
          await this.setState({ erroXLSX: msg })
          return
        }
      }
      await this.setState({ erroXLSX: "", verificado: true })
    } finally {
      this.setState({
        verifyingData: false,
        verifyingDataProgress: { verified: 0, total: 0 }
      })
    }
  }

  async removeExistingUsers() {
    const fullList = this.filterUsers(this.state.usersList)
    const total = fullList.length
    if (total === 0) {
      this.refs.notificationAlert.notificationAlert({
        place: "tr",
        message: (
          <div className="alert-text">
            <span className="alert-title" data-notify="title">Aviso</span>
            <span data-notify="message">Nenhum usuário na planilha para verificar.</span>
          </div>
        ),
        type: "warning",
        icon: "fas fa-info-circle",
        autoDismiss: 5
      })
      return
    }

    const CHUNK_SIZE = 150
    const allIndicesToRemove = []
    this.setState({
      removingExisting: true,
      removingExistingProgress: { verified: 0, total }
    })

    try {
      for (let start = 0; start < total; start += CHUNK_SIZE) {
        const end = Math.min(start + CHUNK_SIZE, total)
        const chunk = fullList.slice(start, end)
        const payload = { list: chunk, startIndex: start, returnExisting: true }
        const data = await this.helper.user().userCheckXlsx(payload)
        this.setState({ removingExistingProgress: { verified: end, total } })

        if (!data) {
          throw new Error("Erro de conexão. Tente novamente.")
        }
        const responseData = data.data?.data || data.data || {}
        let indices = responseData.existingIndices
        if (!indices && Array.isArray(responseData.existingUsernames) && responseData.existingUsernames.length > 0) {
          const setExisting = new Set(responseData.existingUsernames.map(u => (u || "").toString().toLowerCase().trim()))
          indices = chunk
            .map((u, i) => (setExisting.has((u.username || "").toString().toLowerCase().trim()) ? start + i : -1))
            .filter(i => i >= 0)
        }
        if (Array.isArray(indices) && indices.length > 0) {
          allIndicesToRemove.push(...indices)
        }
        if (data.status !== 200 && (!indices || indices.length === 0)) {
          const msg = responseData.msg || "Erro ao verificar dados."
          throw new Error(msg)
        }
      }

      const indicesSet = new Set(allIndicesToRemove)
      if (indicesSet.size === 0) {
        this.refs.notificationAlert.notificationAlert({
          place: "tr",
          message: (
            <div className="alert-text">
              <span className="alert-title" data-notify="title">Remover existentes</span>
              <span data-notify="message">Nenhum usuário da planilha já existe no sistema.</span>
            </div>
          ),
          type: "info",
          icon: "fas fa-info-circle",
          autoDismiss: 7
        })
      } else {
        const usersList = this.state.usersList.filter((_, i) => !indicesSet.has(i))
        await this.setState({ usersList, verificado: false })
        this.checkXlsxServer()
        this.refs.notificationAlert.notificationAlert({
          place: "tr",
          message: (
            <div className="alert-text">
              <span className="alert-title" data-notify="title">Removidos</span>
              <span data-notify="message">{indicesSet.size} usuário(s) já existente(s) foram removidos da listagem.</span>
            </div>
          ),
          type: "success",
          icon: "ni ni-check-bold",
          autoDismiss: 7
        })
      }
    } catch (err) {
      this.refs.notificationAlert.notificationAlert({
        place: "tr",
        message: (
          <div className="alert-text">
            <span className="alert-title" data-notify="title">Erro</span>
            <span data-notify="message">{err.message || "Erro ao remover existentes. Tente novamente."}</span>
          </div>
        ),
        type: "danger",
        icon: "fas fa-exclamation",
        autoDismiss: 7
      })
    } finally {
      this.setState({
        removingExisting: false,
        removingExistingProgress: { verified: 0, total: 0 }
      })
    }
  }

  async checkXlsx() {
    await this.setState({ importError: "" })
    if ($("#input_xlsx")[0].files[0] === undefined) {
      return false
    }
    $("label[for='input_xlsx']").html(
      $("#input_xlsx")[0].files[0].name
    )
    const input = $("#input_xlsx")
    const file = input[0].files
    let users = []
    const userscheck = []
    if (file.length === 0) {
      this.setState({
        importError: this.props.translate["voce_deve_selecionar_o_arquivo"]
      })
      return false
    }
    try {
      await readXlsxFile(file[0]).then(rows => {
        users = rows
      })
    } catch (error) {
      this.setState({
        importError: this.props.translate["nao_foi_possivel_abrir_o_arquivo"]
      })
      return false
    }

    if (users.length !== 0) {
      if (users.length === 1) {
        this.setState({
          importError: this.props.translate["o_arquivo_enviado_esta_vazio"]
        })
        return false
      }
      for (let index = 1; index < users.length; index++) {
        for (let c = 0; c <= 11; c++) {
          if (users[index][c] === undefined || users[index][c] === null) {
            users[index][c] = ""
          }
        }
        try {
          const userparse = {}
          userparse.name = users[index][0]?.toString().trim() || ""
          userparse.lastName = users[index][1]?.toString().trim() || ""
          userparse.email = users[index][2]?.toString().trim() || ""
          userparse.username = users[index][3]?.toString().trim() || ""
          userparse.genre = users[index][4]?.toString().trim() || ""
          const genre = ["0", "m", "masculino", "homem", "male"]
          try {
            userparse.genre = userparse.genre.toLowerCase()
            if (genre.indexOf(userparse.genre) !== -1) {
              userparse.genre = 0
            } else {
              userparse.genre = 1
            }
          } catch (error) {}
          userparse.birthDate = users[index][5]
          if (users[index][5] !== "") {
            userparse.birthDate = await moment(users[index][5]).format(
              "DD/MM/YYYY"
            )
          }
          
          // Nível de acesso - busca pelo nome (ex: "Aluno", "Professor")
          userparse.accessLevel = users[index][6]?.toString().trim() || ""
          const accessLevelOriginal = userparse.accessLevel
          try {
            const accessLevelLower = userparse.accessLevel.toLowerCase()
            for (let index2 = 0; index2 < this.props.state.levelAcess.length; index2++) {
              if (this.props.state.levelAcess[index2].name.toLowerCase() === accessLevelLower) {
                userparse.accessLevel = this.props.state.levelAcess[index2].id
                break
              }
            }
          } catch (error) {
            console.log("Erro ao processar nível de acesso:", error)
          }
          // Se não encontrou pelo nome, tenta como ID numérico
          if (userparse.accessLevel === accessLevelOriginal && accessLevelOriginal !== "") {
            const numId = parseInt(accessLevelOriginal)
            if (!isNaN(numId)) {
              userparse.accessLevel = numId
            }
          }
          
          // Bloqueio QR Code - vazio = desativado (0)
          userparse.blockedQRcode = users[index][7]?.toString().trim() || ""
          const passBlockedQRcode = ["sim", "yes", "s", "y", "1", "true"]
          try {
            userparse.blockedQRcode = userparse.blockedQRcode.toLowerCase()
          } catch (error) {}
          if (userparse.blockedQRcode !== "" && passBlockedQRcode.indexOf(userparse.blockedQRcode) !== -1) {
            userparse.blockedQRcode = 1
          } else {
            userparse.blockedQRcode = 0
          }
          
          // Bloqueio Total - vazio = desativado (0)
          userparse.blocked = users[index][8]?.toString().trim() || ""
          try {
            userparse.blocked = userparse.blocked.toLowerCase()
          } catch (error) {}
          if (userparse.blocked !== "" && passBlockedQRcode.indexOf(userparse.blocked) !== -1) {
            userparse.blocked = 1
          } else {
            userparse.blocked = 0
          }
          
          // Senha - converte para string (pode vir como número do Excel)
          userparse.password = users[index][9]?.toString() || ""
          
          userparse.classRooms = JSON.parse(
            JSON.stringify(this.props.state.classRoom)
          )
          userparse.classRoom = []
          try {
            const colTurmas = users[index][10]
            if (colTurmas != null && typeof colTurmas === "string" && colTurmas.trim() !== "") {
              const nomesTurmas = colTurmas.split(/[,;]/).map(s => s.trim()).filter(Boolean)
              const tipagem = (users[index][11] != null ? users[index][11].toString() : "")
                .split(/[,;]/).map(s => s.trim())
              const classRoomList = this.props.state.classRoom
              const permitions = (window.app && window.app.state && window.app.state.permitions) ? window.app.state.permitions : []
              for (let indexcc = 0; indexcc < nomesTurmas.length; indexcc++) {
                const nomeDigitado = this.normalizeTurmaName(nomesTurmas[indexcc])
                if (!nomeDigitado) continue
                for (let index3 = 0; index3 < classRoomList.length; index3++) {
                  const nomeSistema = this.normalizeTurmaName(classRoomList[index3].name)
                  if (nomeSistema === nomeDigitado) {
                    const cls = JSON.parse(JSON.stringify(classRoomList[index3]))
                    cls.type = "4"
                    userparse.classRooms[index3].type = "4"
                    if (tipagem[indexcc] !== undefined && tipagem[indexcc] !== "") {
                      const tpiNorm = this.normalizeTurmaName(tipagem[indexcc])
                      for (let indextps = 0; indextps < permitions.length; indextps++) {
                        if (this.normalizeTurmaName(permitions[indextps].name) === tpiNorm) {
                          cls.type = permitions[indextps].id
                          userparse.classRooms[index3].type = permitions[indextps].id
                          break
                        }
                      }
                    }
                    userparse.classRoom.push(cls)
                    break
                  }
                }
              }
            }
          } catch (error) {}
          userscheck.push(userparse)
        } catch (error) {
          this.setState({
            importError: this.props.translate["nao_foi_possivel_abrir_o_arquivo"]
          })
        }
      }
      if (this.state.importError === "") {
        await this.setState({ usersList: userscheck, importError: "" })
        this.checkXlsxServer()
      }
    } else {
      this.setState({
        importError: this.props.translate["nao_foi_possivel_abrir_o_arquivo"]
      })
    }
  }

  filterUsers(obj) {
    const obj2 = JSON.parse(JSON.stringify(obj))
    for (let index = 0; index < obj2.length; index++) {
      obj2[index].birthDate = moment(
        obj2[index].birthDate,
        "DD/MM/YYYY"
      ).format("YYYY-MM-DD")
      obj2[index].company = this.props.user.preference.selectcompany
    }
    return obj2
  }

  changeValue(index, value, position) {
    const usersList = [...this.state.usersList]
    usersList[index][position] = value
    this.setState({ usersList, verificado: false })
  }

  reset() {
    this.setState({
      usersList: [],
      verificado: false,
      removingExisting: false,
      removingExistingProgress: { verified: 0, total: 0 },
      verifyingData: false,
      verifyingDataProgress: { verified: 0, total: 0 },
      cadastrando: false,
      cadastrandoProgress: { current: 0, total: 0 }
    })
  }

  render() {
    let st = {}
    if (this.state.usersList.length !== 0) {
      st = { maxWidth: "98%" }
    }
    const isLoading = this.state.removingExisting || this.state.verifyingData || this.state.cadastrando
    const loadingTitle = this.state.cadastrando
      ? "Cadastrando usuários..."
      : this.state.removingExisting
        ? "Removendo usuários já existentes..."
        : "Verificando dados..."
    const loadingProgress = this.state.cadastrando
      ? this.state.cadastrandoProgress
      : this.state.removingExisting
        ? this.state.removingExistingProgress
        : this.state.verifyingDataProgress

    return (
      <React.Fragment>
        <div className="rna-wrapper">
          <NotificationAlert ref="notificationAlert" />
        </div>
        {isLoading && (
          <div
            style={{
              position: "fixed",
              inset: 0,
              left: 0,
              top: 0,
              right: 0,
              bottom: 0,
              background: "rgba(0,0,0,0.4)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              zIndex: 9999
            }}
          >
            <div
              style={{
                background: "#fff",
                borderRadius: "12px",
                padding: "2rem 2.5rem",
                boxShadow: "0 10px 40px rgba(0,0,0,0.2)",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                minWidth: "280px"
              }}
            >
              <div className="spinner-border text-primary" role="status" style={{ width: "3rem", height: "3rem" }}>
                <span className="sr-only">Carregando...</span>
              </div>
              <p className="mt-3 mb-1 font-weight-bold text-dark" style={{ fontSize: "1.05rem" }}>{loadingTitle}</p>
              <p className="text-muted small mb-0">
                {(loadingProgress.verified ?? loadingProgress.current)} de {loadingProgress.total}
                {this.state.cadastrando ? "" : " (em lotes)"}
              </p>
            </div>
          </div>
        )}
        <Modal
          className="modal-dialog-centered"
          style={st}
          isOpen={this.props.state.openModalImport}
        >
          <div className="modal-body p-0">
            <Card className="bg-secondary border-0 mb-0">
              <div className="modal-header">
                <h6 className="modal-title" id="modal-title-default">
                  {this.props.translate["importar_por_planilha"]}
                </h6>
                <button
                  aria-label="Close"
                  className="close"
                  data-dismiss="modal"
                  type="button"
                  onClick={() => {
                    this.setStateTop({ openModalImport: false })
                    this.reset()
                  }}
                >
                  <span aria-hidden={true}>×</span>
                </button>
              </div>
              <CardBody className="">
                <Form role="form" type="post" onSubmit={event => this.props.saveUser(event)}>
                  {this.state.importError !== "" && (
                    <Alert color="danger" className="animated tada">
                      <strong>{this.props.translate["ops"]}! </strong>
                      {this.state.importError}
                    </Alert>
                  )}
                  {this.state.usersList.length === 0 && (
                    <React.Fragment>
                      <center>
                        <font>{this.props.translate["selecione_o_arquivo"]}:</font>
                      </center>
                      <div style={{ display: "flex", gap: "0.5rem", flexWrap: "wrap", justifyContent: "center" }}>
                        <div className="custom-file form-control-sm" style={{ maxWidth: "300px" }}>
                          <input
                            onChange={event => {
                              this.checkXlsx()
                            }}
                            className="custom-file-input"
                            id="input_xlsx"
                            type="file"
                          />
                          <label
                            className="custom-file-label"
                            htmlFor="input_xlsx"
                          >
                            {this.props.translate["selecionar_arquivo"]}
                          </label>
                        </div>
                        <Button
                          onClick={() => this.checkXlsx()}
                          color="secondary"
                          type="button"
                          style={{ height: "44px" }}
                        >
                          <i className="ni ni-cloud-upload-96"></i>{" "}
                          {this.props.translate["enviar"]}
                        </Button>
                      </div>
                      <div className="text-center mt-3">
                        <small className="text-muted d-block mb-2">
                          Tem uma planilha em outro formato?
                        </small>
                        <Button
                          onClick={() => {
                            this.setStateTop({ openModalImport: false, openSmartConverter: true })
                          }}
                          color="info"
                          type="button"
                          size="sm"
                        >
                          <i className="fas fa-magic mr-1"></i>
                          Conversor Inteligente de Planilhas
                        </Button>
                      </div>
                    </React.Fragment>
                  )}
                  {this.state.usersList.length !== 0 && (
                    <React.Fragment>
                      {this.state.erroXLSX !== "" && (
                        <div className="container">
                          <div
                            className="alert alert-danger animated tada"
                            role="alert"
                          >
                            <strong>{this.props.translate["ops"]}! </strong>
                            {this.state.erroXLSX}
                          </div>
                        </div>
                      )}
                      {this.state.erroXLSX === "" && this.state.verificado === true && (
                        <div className="container">
                          <div
                            className="alert alert-success animated fadeIn"
                            role="alert"
                          >
                            <strong>
                              <i className="fas fa-check"></i>
                            </strong>{" "}
                            {this.props.translate["tudo_pronto_para_cadastrar"]}
                          </div>
                        </div>
                      )}
                      <div className="table-responsive div_tab_importxlsx">
                        <table className="align-items-center table-flush table table_importXLXS">
                          <thead className="thead-light">
                            <tr>
                              <th style={{ width: "40px" }}>#</th>
                              <th>{this.props.translate["nome"]}</th>
                              <th>{this.props.translate["sobrenome"]}</th>
                              <th>{this.props.translate["email"]}</th>
                              <th>{this.props.translate["usuario"]}</th>
                              <th style={{ width: "80px" }}>{this.props.translate["sexo"]}</th>
                              <th style={{ width: "100px" }}>{this.props.translate["nascimento"]}</th>
                              <th style={{ width: "100px" }}>{this.props.translate["tipo"]}</th>
                              <th style={{ width: "100px" }}>{this.props.translate["senha"]}</th>
                              <th>{this.props.translate["turma"]}</th>
                              <th style={{ width: "40px" }}></th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.usersList.map((value, index) => {
                              return (
                                <tr key={`input_xlsx_${index}`}>
                                  <td>{index + 1}</td>
                                  <td>
                                    <input
                                      onChange={event =>
                                        this.changeValue(index, event.target.value, "name")
                                      }
                                      value={this.state.usersList[index].name}
                                      placeholder="Nome"
                                    />
                                  </td>
                                  <td>
                                    <input
                                      onChange={event =>
                                        this.changeValue(index, event.target.value, "lastName")
                                      }
                                      value={this.state.usersList[index].lastName}
                                      placeholder="Sobrenome"
                                    />
                                  </td>
                                  <td>
                                    <input
                                      onChange={event =>
                                        this.changeValue(index, event.target.value, "email")
                                      }
                                      value={this.state.usersList[index].email}
                                      type="email"
                                      placeholder="email@exemplo.com"
                                    />
                                  </td>
                                  <td>
                                    <input
                                      onChange={event =>
                                        this.changeValue(index, event.target.value, "username")
                                      }
                                      value={this.state.usersList[index].username}
                                      placeholder="login"
                                    />
                                  </td>
                                  <td>
                                    <select
                                      value={this.state.usersList[index].genre}
                                      onChange={event =>
                                        this.changeValue(index, event.target.value, "genre")
                                      }
                                    >
                                      <option value=""></option>
                                      <option value="0">{this.props.translate["masculino"]}</option>
                                      <option value="1">{this.props.translate["feminino"]}</option>
                                    </select>
                                  </td>
                                  <td>
                                    <InputMask
                                      onChange={event =>
                                        this.changeValue(index, event.target.value, "birthDate")
                                      }
                                      value={this.state.usersList[index].birthDate}
                                      mask="99/99/9999"
                                      maskChar=""
                                      placeholder="DD/MM/AAAA"
                                      onFocus={() => this.setState({ focusedNascimento: true })}
                                      onBlur={() => this.setState({ focusedNascimento: false })}
                                    />
                                  </td>
                                  <td>
                                    <select
                                      value={this.state.usersList[index].accessLevel}
                                      onChange={event =>
                                        this.changeValue(index, event.target.value, "accessLevel")
                                      }
                                    >
                                      <option value=""></option>
                                      {this.props.state.levelAcess.map((val, idx) => {
                                        return (
                                          <option value={val.id} key={`access_${index}_${idx}`}>
                                            {val.name}
                                          </option>
                                        )
                                      })}
                                    </select>
                                  </td>
                                  <td>
                                    <input
                                      onChange={event =>
                                        this.changeValue(index, event.target.value, "password")
                                      }
                                      value={this.state.usersList[index].password}
                                      placeholder="senha"
                                    />
                                  </td>
                                  <td>
                                    <div className="input_select_custom_importa_usuario">
                                      <Select
                                        placeholder={this.props.translate["selecione_as_turmas"]}
                                        itemRenderer={({ item, methods }) => (
                                          <div>
                                            {item.disabled ? (
                                              <div className="custom-control custom-checkbox">
                                                <input className="custom-control-input" type="checkbox" />
                                                <label className="custom-control-label">{item.name}</label>
                                              </div>
                                            ) : (
                                              <div
                                                style={{ display: "flex", alignItems: "center" }}
                                                className="custom-control custom-checkbox"
                                              >
                                                <input
                                                  checked={methods.isSelected(item)}
                                                  className="custom-control-input"
                                                  type="checkbox"
                                                />
                                                <label
                                                  onClick={() => {
                                                    if (item.type !== undefined && item.type !== "") {
                                                      methods.addItem(item)
                                                    } else {
                                                      const a = `.select_tt_${item.id}_line_${index}`
                                                      $(a).removeClass("flash")
                                                      setTimeout(() => {
                                                        $(a).addClass("animated")
                                                        $(a).addClass("flash")
                                                      }, 100)
                                                    }
                                                  }}
                                                  className="custom-control-label"
                                                >
                                                  {item.name}
                                                </label>
                                                <div style={{ marginLeft: "8px" }}>
                                                  Tipo:
                                                  <select
                                                    className={`select_tt_${item.id}_line_${index}`}
                                                    value={item.type}
                                                    onChange={event => {
                                                      if (event.target.value === "") {
                                                        return false
                                                      }
                                                      item.type = event.target.value
                                                      this.setState({ a: "1" })
                                                      const index24 = this.state.usersList[
                                                        index
                                                      ].classRoom.map(function(x) {
                                                        return x.id
                                                      }).indexOf(item.id)
                                                      if (index24 === -1) {
                                                        methods.addItem(item)
                                                      }
                                                    }}
                                                    style={{
                                                      boxShadow: "0px 1px 3px -2px #000",
                                                      borderRadius: "4px",
                                                      marginLeft: "6px",
                                                      fontSize: "0.85rem"
                                                    }}
                                                  >
                                                    <option value=""></option>
                                                    {window.app.state.permitions.map((val2, ind2) => {
                                                      return (
                                                        <option value={val2.id} key={`perm_${index}_${ind2}`}>
                                                          {val2.name}
                                                        </option>
                                                      )
                                                    })}
                                                  </select>
                                                </div>
                                              </div>
                                            )}
                                          </div>
                                        )}
                                        labelField="name"
                                        values={this.state.usersList[index].classRoom}
                                        onChange={event => this.changeValue(index, event, "classRoom")}
                                        valueField="id"
                                        multi
                                        options={this.state.usersList[index].classRooms}
                                      />
                                    </div>
                                  </td>
                                  <td>
                                    <i
                                      style={{ cursor: "pointer", color: "#d9534f" }}
                                      onClick={() => this.removeLine(index)}
                                      className="far fa-trash-alt"
                                    ></i>
                                  </td>
                                </tr>
                              )
                            })}
                          </tbody>
                        </table>
                      </div>
                    </React.Fragment>
                  )}
                  <div className="text-center">
                    {this.state.usersList.length !== 0 && (
                      <Button
                        className="my-2"
                        color="danger"
                        type="button"
                        onClick={() => {
                          this.setStateTop({ openModalImport: false })
                          this.reset()
                        }}
                      >
                        <i className="far fa-times-circle"></i> {this.props.translate["cancelar"]}
                      </Button>
                    )}
                    <Link target="_blank" download to="/planilha/Template de importacao de usuario.xlsx">
                      <Button className="my-2" color="default" type="button">
                        <i className="fas fa-file-download"></i> {this.props.translate["baixar_template"]}
                      </Button>
                    </Link>
                    {this.state.usersList.length === 0 && (
                      <Button
                        className="my-2"
                        color="secondary"
                        type="button"
                        onClick={() => {
                          this.manual()
                        }}
                      >
                        <i className="fas fa-list-ol"></i> {this.props.translate["cadastrar_manualmente"]}
                      </Button>
                    )}
                    {this.state.usersList.length !== 0 && (
                      <Button
                        className="my-2"
                        color="secondary"
                        type="button"
                        onClick={() => {
                          this.addLine()
                        }}
                      >
                        <i className="fas fa-plus"></i> {this.props.translate["adicionar_linha"]}
                      </Button>
                    )}
                    {this.state.usersList.length !== 0 && (
                      <React.Fragment>
                        {this.state.verificado === false && (
                          <Button
                            className="my-2"
                            color="secondary"
                            type="button"
                            disabled={isLoading}
                            onClick={() => this.checkXlsxServer()}
                          >
                            <i className="fas fa-user-check"></i> {this.props.translate["verificar_dados"]}
                          </Button>
                        )}
                        <Button
                          className="my-2"
                          color="warning"
                          type="button"
                          disabled={isLoading}
                          onClick={() => this.removeExistingUsers()}
                          title="Remove da listagem os usuários que já existem no sistema (alunos/usuários já cadastrados)"
                        >
                          <i className="fas fa-user-minus"></i> Remover já existentes
                        </Button>
                        {this.state.erroXLSX === "" && this.state.verificado === true && (
                          <Button
                            className="my-2"
                            color="success"
                            type="button"
                            disabled={isLoading}
                            onClick={() => this.cadastrar()}
                          >
                            <i className="fas fa-paper-plane"></i> {this.props.translate["cadastrar"]}
                          </Button>
                        )}
                      </React.Fragment>
                    )}
                  </div>
                </Form>
              </CardBody>
            </Card>
          </div>
        </Modal>
      </React.Fragment>
    )
  }
}

export default connect(state => ({
  languages: state.language,
  translate: state.translate,
  accesslevel: state.accesslevel,
  permission: state.permission,
  user: state.user
}))(ImportXlsxUser)
